var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("span", { staticClass: "badge bg-dark" }, [
        _vm._v(_vm._s(_vm._f("translate")("Question"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.component.data.question.html) },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm._l(_vm.answers, function (answer, index) {
            return _c("div", { key: index, staticClass: "mb-3 form-check" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: answer.selected,
                    expression: "answer.selected",
                  },
                ],
                ref: `answer${index}`,
                refInFor: true,
                staticClass: "form-check-input",
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(answer.selected)
                    ? _vm._i(answer.selected, null) > -1
                    : answer.selected,
                },
                on: {
                  change: [
                    function ($event) {
                      var $$a = answer.selected,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(answer, "selected", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              answer,
                              "selected",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(answer, "selected", $$c)
                      }
                    },
                    _vm.answerChanged,
                  ],
                },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "form-check-label" }, [
                _vm._v(_vm._s(answer.label)),
              ]),
            ])
          }),
          _vm._v(" "),
          _vm.showSolution
            ? _c("div", { staticClass: "my-3" }, [
                _vm.answerIsValid
                  ? _c("div", [
                      _c("i", { staticClass: "fas fa-trophy text-warning" }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("translate")("Correct. Congratulations!")
                          ) +
                          "\n        "
                      ),
                    ])
                  : _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("translate")(
                              "Wrong answer, please try again."
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm fw-bold",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.check.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("Check my answer")) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-link btn-sm",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleHint.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("Solution")) +
                  "\n      "
              ),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showHint
        ? _c("div", {
            staticClass: "lecture--quiz--hint col-12 pt-3 mt-3",
            domProps: { innerHTML: _vm._s(_vm.component.data.solution.html) },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }